import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LabelService {

constructor(private http: HttpClient) { }

  baseUrl = environment.apiUrl;
  
getSDSById(searchString){
  return this.http.get(this.baseUrl + `products/MsdsId?searchString=${searchString}`);
}

getPrecautionaryStatement(searchString){
  return this.http.get(this.baseUrl + `products/PrecautionaryStatement?searchString=${searchString}`);
}

getPictograms(searchString) {
  return this.http.get(this.baseUrl + `products/Pictogram?searchString=${searchString}`);
}

getPictogramUrls() {
  return this.http.get(this.baseUrl + 'whmis2015/pictogramUrls');
}

getLabelPictograms() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'sdslabel/pictograms', {headers: httpHeaders});
}

generateWorkPlaceLabel(model: any, pictogramName: any): Observable<any> {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.post(this.baseUrl + `sdslabel/CreateLabel?${pictogramName}`, model , {headers: httpHeaders, responseType: 'blob'});
}
}
